var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "nav-wrap" },
        [_c("nav-bar", { attrs: { routers: _vm.routers } })],
        1
      ),
      _c("router-view", {
        attrs: {
          "grade-id": _vm.gradeId,
          "subject-list": _vm.mainSubjectList,
          "school-id": _vm.schoolId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }